import { useCallback } from 'react';

export const useStorage = <V extends string | undefined>(key: string) => {
  const get = useCallback((): V => {
    try {
      const value = global.localStorage.getItem(key);
      // key might have been set on global window
      // get'ing from localStorage may not throw even if setting does
      // cast empty string to undefined
      // @ts-expect-error window access
      return value || global[key] || undefined;
    } catch (_e) {
      // @ts-expect-error window access
      return global[key] || undefined;
    }
  }, [key]);

  const set = useCallback(
    (value: string | undefined) => {
      const newValue = value || '';
      try {
        global.localStorage.setItem(key, newValue);
      } catch (_e) {
        // @ts-expect-error window access
        global[key] = value;
      }
    },
    [key],
  );

  return [get, set] as const;
};
